import { render, staticRenderFns } from "./SkeletonComboAdditionsKiosk.vue?vue&type=template&id=59a93fa4&"
import script from "./SkeletonComboAdditionsKiosk.vue?vue&type=script&lang=js&"
export * from "./SkeletonComboAdditionsKiosk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports